import APIConfiguration from '@savgroup-front-common/configuration/api';
import { COMMON_QUERY_PARAMS } from '@savgroup-front-common/constants';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.workflow}files/${COMMON_QUERY_PARAMS.FILE_ID}/actions`;

export interface GetWorkTypeBySellerQueryPayload {
  fileId: string;
}

export interface StateSummaryDto {
  fileId: string;
  module: {
    id: string;
    definitionId: string;
    referencedModuleType: string;
    wave: number;
    parameters: {
      additionalProp1: string;
      additionalProp2: string;
      additionalProp3: string;
    };
  };
  stateDate: string;
  priority: number;
  currentState: {
    name: string;
    shortLabel: string;
    label: string;
  };
  transitions: [
    {
      label: string;
      targetState: {
        name: string;
        shortLabel: string;
        label: string;
      };
      required: boolean;
      expects: {
        mandatories: string[];
        optionals: string[];
      };
      isCommentMandatory: boolean;
      isCommentForCustomerAvailable?: boolean;
    },
  ];
}

export const getUserActionsRequest = ({
  fileId,
}: GetWorkTypeBySellerQueryPayload): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, fileId),
  config: { method: SUPPORTED_METHODS.GET },
});

export const getUserActionsQuery = async ({
  fileId,
}: GetWorkTypeBySellerQueryPayload): Promise<
  BackResponse<StateSummaryDto[]> | BackResponseFailure
> => {
  try {
    return await executeQuery<BackResponse<StateSummaryDto[]>>(
      getUserActionsRequest({ fileId }),
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};
